// export default () => ({
// })

export default () => ({
    outputs: [],
    outputsSelectable: [],
    outputSelect: null,
    outputsPaginatedData: null,
    output: null,
    isLoading: false,
    isCreating: false,
    createdData: null,
    isUpdating: false,
    updatedData: null,
    isDeleting: false,
    deletedData: null,
    cancelatedData: null,
    isCancelating: false
})